import '../components/axios.js';
import { Modal, Tooltip, Alert } from 'bootstrap';
import Cookie from '../../../../dev/js/components/cookie.js';
import AuthService from '../services/auth-service.js';
import ReCaptchaService from '../services/recaptcha-service.js';
import initPrototypes from '../components/prototypes.js';
import { getPublicUrl } from '../components/utils.js';

window.BS_VERSION = parseFloat(Tooltip.VERSION);
window.dataLayer = window.dataLayer || [];
window.Cookie = Cookie;
initPrototypes();

document.addEventListener('DOMContentLoaded', () => {
	window.reCaptchaService = new ReCaptchaService();
	window.reCaptchaService.init(); // TODO: it can be deleted after public.js isn't used anymore
	window.authService = new AuthService();
	window.authService.init();

	window.authService.on("closed", function () {
		if (Cookie.get('report')) {
			let destination = new URL(decodeURIComponent(Cookie.get('report')));
			console.log('Redirecting to:', destination, getPublicUrl().includes(destination.hostname));
			if (getPublicUrl().includes(destination.hostname)) {
				Cookie.delete('report');
				location.href = destination.href;
			} else if (history.length > 1) {
				console.log('Redirecting back to:', history.state);
				Cookie.delete('report');
				history.back();
			}
		} else {
			console.log('Reload');
			location.reload();
		}
	});
});